import React from "react";
import { colors } from "../../theme/colors";
import InfoIcon from "@mui/icons-material/Info";
import CircleIcon from "@mui/icons-material/Circle";

const StatusColors = ({ statuses }) => {
  const getStatusColor = (value) => {
    switch (value) {
      case "0":
        return "#ff3241"; // Draft - Orange
      case "1":
        return "#4082C1"; // Ready to Review - Green
      case "2":
        return "#54B196"; // Reviewed - Dark Green
      case "3":
        return "#E53935"; // Rejected - Red
      case "4":
        return "#EDAF68"; // Return to Doctor - Gray
      case "5":
        return "#4082C1"; // Return to Quality - Blue
      case "6":
        return "#666666"; // Return to Quality - Blue
      default:
        return colors.PRIMARY_DARK;
    }
  };

  return (
    <div style={{ marginTop: "20px", display: "inline-block" }}>
      {statuses.map((status, index) => (
        <div
          key={index}
          style={{
            display: "flex",
            marginRight: "20px",
            alignItems: "center",
            marginBottom: "5px",
            fontSize: "12px",
          }}
        >
          {status.value == 0 && (
            <InfoIcon
              sx={{
                fontSize: "16px",
                color: status.color || getStatusColor(status.value),
                marginRight: "5px",
              }}
            />
          )}
          {status.value != 0 && (
            <CircleIcon
              sx={{
                fontSize: "16px",
                color: status.color || getStatusColor(status.value),
                marginRight: "5px",
              }}
            />
          )}
          <span>{status.label}</span>
        </div>
      ))}
    </div>
  );
};

export default StatusColors;
